import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import Image from 'components/common/image';
import type { DrawingType } from '../../types';
import type { DisplayedFile } from '../../../gallery/filesStore';
import { thumbnailService } from 'services/fileService';
import { getListImageContentSx, listImageSpinnerContainerSx } from '../../styles';
import { ListItemFrame, type ListItemFrameProps } from './ListItemFrame';

interface ImageListItemProps extends ListItemFrameProps {
  image: DisplayedFile;
  drawing: DrawingType;
  error: boolean;
  isLoaded: boolean;
  setLoaded: () => void;
  onError: () => void;
  imageClassName: string;
}

/** A tile of an image: its thumbnail, or a spinner until it loads. */
export const ImageFileListItem: React.FC<ImageListItemProps> = ({
  image,
  drawing,
  error,
  isLoaded,
  setLoaded,
  onError,
  imageClassName,
  ...frameProps
}) => {
  const { description, onClick } = frameProps;
  const src = thumbnailService.resolveListImageSrc(error, drawing, image);
  const { showSpinner, imageOpacity } =
    thumbnailService.resolveListImageDisplayState({
      src,
      isLoaded,
      error,
    });

  return (
    <ListItemFrame {...frameProps}>
      {showSpinner && (
        <Box sx={listImageSpinnerContainerSx}>
          <CircularProgress />
        </Box>
      )}
      <Box sx={getListImageContentSx(imageOpacity)}>
        {src !== null && (
          <Image
            className={imageClassName}
            imageRotation={image.imageRotation}
            description={description}
            src={src}
            setLoaded={setLoaded}
            onError={onError}
            onClick={onClick}
          />
        )}
      </Box>
    </ListItemFrame>
  );
};
